import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=39c494fc&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=39c494fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c494fc",
  null
  
)

export default component.exports